import { IconChecklist, IconEdit, IconTrash } from '@tabler/icons-react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';

import { RowActions } from 'src/Components/Shared/RowActions';
import useFetchUser from 'src/Hooks/Queries/useFetchUser';

import styles from './Settings.module.scss';
import { Props } from './Settings.props';

const Settings = ({ feedItem, onEdit, onDelete }: Props) => {
  const { t } = useTranslation();
  const { data: user } = useFetchUser();
  const navigate = useNavigate();

  const isMine = user?.id === feedItem.author.id;
  const isUGC = feedItem.type.startsWith('POST');
  const canEdit = isMine && isUGC;
  const canDelete = isMine;

  // Can create task if user belongs to at least one of the feed item's assets
  const firstAsset = feedItem.assets[0];
  const canCreateTask = !!firstAsset;

  const canDoAnything = canEdit || canDelete || canCreateTask;

  const handleCreateTask = () => {
    if (!firstAsset) return;
    navigate(`/asset/${firstAsset.id}/tasks/new?communityFeedItemId=${feedItem.id}`);
  };

  if (!canDoAnything) return null;

  return (
    <div className={styles.settings}>
      <RowActions
        actions={[
          {
            key: 'create-task',
            label: t('community.createTask', 'Créer une tâche'),
            icon: <IconChecklist size={18} />,
            hidden: !canCreateTask,
            onClick: handleCreateTask,
          },
          {
            key: 'edit',
            label: t('common.edit', 'Modifier'),
            icon: <IconEdit size={18} />,
            hidden: !canEdit,
            onClick: onEdit,
          },
          {
            key: 'delete',
            label: t('common.delete', 'Supprimer'),
            icon: <IconTrash size={18} />,
            variant: 'danger',
            hidden: !canDelete,
            onClick: onDelete,
          },
        ]}
      />
    </div>
  );
};

export default Settings;
